import React, { useState } from 'react';
import $ from 'jquery';
import { Rnd } from 'react-rnd';
import panoJpg from '../../assets/img/pano.jpeg';
import { Button } from 'antd';
import SessionManager from '../../routes/SessionManager';
import Toastr from 'toastr';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 3px red",
    background: "rgba(255, 0, 0, 0.1)",
    cursor: "move",
    boxShadow: "0 0 10px rgba(255, 0, 0, 0.5)"
};

const PeepCamera = (props) => {
    const [modified, setModified] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [width, setWidth] = useState(50);
    // const [height, setHeight] = useState(50);

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user', true);

    const videoElement = $('#axis-video')[0];
    const wh = videoElement ? [videoElement.offsetWidth || window.innerWidth, videoElement.offsetHeight || window.innerHeight] : [window.innerWidth, window.innerHeight];

    console.log('PeepCamera - Video dimensions:', wh);
    console.log('PeepCamera - Window dimensions:', [window.innerWidth, window.innerHeight]);

    // Peep box dimensions - use a fixed reasonable size for the viewport indicator
    const peepBoxWidth = 80;  // Fixed width in pixels
    const peepBoxHeight = 60; // Fixed height in pixels

    let ptz_settings = JSON.parse(JSON.stringify(props.ptz));

    for (let p of ['MaxPan', 'MinPan', 'MaxTilt', 'MinTilt', 'MaxZoom', 'MinZoom', 'pan', 'tilt', 'zoom'])
        ptz_settings[p] = parseFloat(ptz_settings[p]);

    if (props.zone && props.zone.location_config && props.zone.location_config.pano_controls) {
        let pano_ctrls = props.zone.location_config.pano_controls;
        ptz_settings['MinTilt'] = pano_ctrls['min_t'];
        ptz_settings['MaxTilt'] = pano_ctrls['max_t'];
        ptz_settings['MaxPan'] = pano_ctrls['max_p'];
        ptz_settings['MinPan'] = pano_ctrls['min_p'];
    }
    console.log('ptz_settings', JSON.stringify(ptz_settings, null, 2));

    const panRange = (ptz_settings.MaxPan - ptz_settings.MinPan);
    const tiltRange = (ptz_settings.MaxTilt - ptz_settings.MinTilt);

    // Changed to full width (100%) and fixed height (150px)
    // Use window width as fallback if wh[0] is invalid
    const panoWidth = wh[0] && !isNaN(wh[0]) ? wh[0] : window.innerWidth;
    let panUnit = (panoWidth / panRange);
    let tiltUnit = (150 / tiltRange);

    console.log('PeepCamera - panUnit:', panUnit, 'tiltUnit:', tiltUnit);

    console.log('panRange, tiltRange', [panRange, tiltRange]);
    // console.log('pan, tilt', [ptz_settings.pan, ptz_settings.tilt]);
    // console.log('panUnit,tiltUnit', [panUnit, tiltUnit]);


    let peepPosX = Math.abs(ptz_settings.pan - ptz_settings.MinPan);
    let peepPosY = Math.abs(ptz_settings.MaxTilt - ptz_settings.tilt); // tilt ranges from bottom(-ve) to up(+ve).

    let isXYValid = !(!(ptz_settings.pan >= ptz_settings.MinPan && ptz_settings.pan <= ptz_settings.MaxPan) ||
        !(ptz_settings.tilt >= ptz_settings.MinTilt && ptz_settings.tilt <= ptz_settings.MaxTilt));

    const [x, setX] = useState(isXYValid ? (peepPosX * panUnit) - (peepBoxWidth * 0.5) : 0);
    const [y, setY] = useState(isXYValid ? (peepPosY * tiltUnit) - (peepBoxHeight * 0.5) : 0);

    let pan1 = ptz_settings.MinPan + ((x + (peepBoxWidth * 0.5)) / panUnit);
    let tilt1 = ptz_settings.MaxTilt > 0 ? ptz_settings.MinTilt + ((y + (peepBoxHeight * 0.5)) / tiltUnit) : - ((y + (peepBoxHeight * 0.5)) / tiltUnit);

    console.log('pan1, tilt1', [pan1, tilt1]);

    const pano_view = 'pano';
    const peep_view = 'peep';

    const applychanges = () => {
        if (isNaN(panUnit) || isNaN(tiltUnit)) {
            console.error('Invalid panUnit or tiltUnit');
            return;
        }
        let pan = ptz_settings.MinPan + ((x + (peepBoxWidth * 0.5)) / panUnit);
        let tilt = ptz_settings.MaxTilt < 0 ? ptz_settings.MinTilt + ((y + (peepBoxHeight * 0.5)) / tiltUnit) : - ((y + (peepBoxHeight * 0.5)) / tiltUnit);
        console.log('Apply changes - pan:', pan, 'tilt:', tilt);
        setLoading(true);
        props.controlCamera('modify', { pan: pan, tilt: tilt, callback: setModified });
    }

    const generatePanoImage = () => {

        let payload = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                device_id: props.zone.device_id,
                location_id: props.zone.location_id,
                site_id: user.site_selected.site_id,
            }
        };

        CommonUtils.ajax(
            {
                url: API.LOCATION.CREATE_PANO,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(payload)
            }
        ).then(
            (res) => {
                if (res.status) {
                    switch (res.status.code) {
                        case 200:
                            Toastr.success('Submitted Request successfully !');
                            break;

                        case 201:
                            Toastr.success('Already a request in progress ...');
                            break;

                        default:
                            break;
                    }

                } else {
                    console.log("Error occurred while submitting pano request");
                }
            },
            (res) => {
                console.log("Error occurred while submitting pano request");
            });
    }

    return (
        <>
            <div id={pano_view} style={{
                position: 'fixed',
                left: 0,
                width: '100%',
                height: '150px',
                bottom: 0,
                backgroundImage: `url(${props.zone ? props.zone.pano_image || panoJpg : panoJpg})`,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 2500
            }}>
                {modified && <Button style={{ position: 'absolute', top: '-40px', right: '10px' }} loading={loading} type="primary" onClick={() => applychanges()}>Apply Changes</Button>}
                {CommonUtils.hasPermission('SITESUPT-UI-PANO-GENERATE') && <Button style={{ position: 'absolute', top: '-40px', left: '10px' }} type="primary" onClick={() => generatePanoImage()}>Generate Pano Image</Button>}

                <Rnd
                    id={peep_view}
                    default={{
                        x: x,
                        y: y,
                        width: peepBoxWidth,
                        height: peepBoxHeight
                    }}
                    style={style}
                    enableResizing={{
                        top: false,
                        right: false,
                        bottom: false,
                        left: false,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false
                    }}
                    disableDragging={false}
                    onMouseDown={(e) => {
                        console.log('Mouse down on peep box');
                    }}
                    onDragStart={(e) => {
                        console.log('Drag started!');
                    }}
                    onDrag={(e, d) => {
                        console.log('Dragging to:', d.x, d.y);
                    }}
                    onDragStop={(e, d) => {
                        console.log('Drag stopped at:', d.x, d.y);
                        setModified(true);
                        setLoading(false);

                        let _x = d.x;
                        let _y = d.y;

                        // Get actual bounds
                        let panoWidth = $('#' + pano_view).width();
                        let panoHeight = $('#' + pano_view).height();

                        // Clamp within bounds
                        _x = Math.max(0, Math.min(_x, panoWidth - peepBoxWidth));
                        _y = Math.max(0, Math.min(_y, panoHeight - peepBoxHeight));

                        console.log('Clamped position:', [_x, _y]);
                        setX(_x);
                        setY(_y);
                    }}
                >
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        textShadow: '1px 1px 2px black',
                        pointerEvents: 'none'
                    }}>
                        <i className="fa fa-arrows-alt"></i>
                    </div>
                </Rnd>
                {!props.zone.pano_image && <span>Panoramic image not found and needs to be generated ... </span>}
            </div >
        </>
    );
};

export default PeepCamera;
